import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Localisation } from '@web-apps/utils-shared'

export const useAccountLocale = (locale?: string) => {
  const { i18n } = useTranslation('app')
  const [appliedLanguage, setAppliedLanguage] = useState<string>()

  const accountLanguage = locale
    ? Localisation.toSupportedLanguage(locale)
    : undefined

  useEffect(() => {
    Localisation.setAccountLocale(locale)
  }, [locale])

  useEffect(() => {
    if (!accountLanguage || accountLanguage === appliedLanguage) return

    if (i18n.language === accountLanguage) {
      setAppliedLanguage(accountLanguage)
      return
    }

    let isSubscribed = true
    i18n.changeLanguage(accountLanguage).finally(() => {
      if (isSubscribed) setAppliedLanguage(accountLanguage)
    })

    return () => {
      isSubscribed = false
    }
  }, [accountLanguage, appliedLanguage, i18n])

  return {
    isLanguageLoading:
      Boolean(accountLanguage) && accountLanguage !== appliedLanguage,
  }
}
